import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { CarregandoService } from 'src/app/services/carregando.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { FuncionarioService } from 'src/app/services/funcionario.service';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { UtilitarioService } from "../../services/utilitario.service";


@Component({
  selector: 'app-transferencia-items-vendedor-modal',
  templateUrl: './transferencia-items-vendedor-modal.component.html',
  styleUrls: ['./transferencia-items-vendedor-modal.component.scss']
})
export class TransferenciaItemsVendedorModalComponent implements OnInit {
  status = [{ id: null, nome: 'Todos' }, { id: true, nome: 'Ativo' }, { id: false, nome: 'Bloqueado' }];
  funcionarios = [];
  funcionariosDe = [];
  funcionariosPara = [];
  statusDe = null;
  statusPara = null;
  funcionarioDe = null;
  funcionarioPara = null;
  idCupom = null;
  idIntegrador = null;
  idContato = null;
  nomeIntegrador = null;

  somentePedido = false;
  somenteIntegrador = false;
  somenteOrcamento = false;

  acoes = {
    TransferirClientesIntegradores: false,
    TransferirOrcamentos: false,
    TransferirPedidos: {
      Sim: false,
      Pendentes: false,
      Confirmados: false,
      Expirados: false,
    }
  };

  public config: PerfectScrollbarConfigInterface = {};

  constructor(
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService,
    private funcionarioService: FuncionarioService,
    public utilitarioService: UtilitarioService,
    private dialogRef: MatDialogRef<TransferenciaItemsVendedorModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    if(data) {
      this.somentePedido = data.somentePedido;
      this.somenteOrcamento = data.somenteOrcamento;
      this.somenteIntegrador = data.somenteIntegrador;

      if(this.somentePedido) this.acoes.TransferirPedidos = { Sim: true, Pendentes: true, Confirmados: true, Expirados: true };
      if(this.somenteOrcamento) this.acoes.TransferirOrcamentos = true;
      if(this.somenteIntegrador) this.acoes.TransferirClientesIntegradores = true;

      this.funcionarioDe = data.funcionarioDe;
      this.idCupom = data.idCupom;
      this.idIntegrador = data.idIntegrador;
      this.idContato = data.idContato;
      this.nomeIntegrador = data.nomeIntegrador;
    }
  }

  ngOnInit(): void {
    this.buscarFuncionarios('de');
    this.buscarFuncionarios('para');
  }

  buscarFuncionarios(tipo: string) {
    this.carregandoService.mostra('buscaFuncionarios');

    let todos = false;
    let somenteAtivos = false;
    let somenteBloqueados = false;

    switch (tipo) {
    case 'de':
      todos = this.statusDe === null;
      somenteAtivos = this.statusDe === true;
      somenteBloqueados = this.statusDe === false;
      break;
    case 'para':
      todos = this.statusPara === null;
      somenteAtivos = this.statusPara === true;
      somenteBloqueados = this.statusPara === false;
      break;
    }

    this.funcionarioService.consultarFuncionarios(todos, somenteAtivos, somenteBloqueados).subscribe(dados => {
      switch (tipo) {
      case 'de':
        this.funcionariosDe = dados;
        break;
      case 'para':
        this.funcionariosPara = dados;
        break;
      }

      this.carregandoService.esconde('buscaFuncionarios');
    }, (erro) => {
      this.carregandoService.esconde('buscaFuncionarios');
      this.notificacaoService.erro(erro);
    });
  }

  onChangeStatusDe() {
    this.buscarFuncionarios('de');
  }

  onChangeStatusPara() {
    this.buscarFuncionarios('para');
  }

  salvar() {
    this.carregandoService.mostra('salvar');

    const vm = {
      funcionarioDe: this.funcionarioDe,
      funcionarioPara: this.funcionarioPara,
      statusDe: this.statusDe,
      statusPara: this.statusPara,
      idCupom: this.idCupom,
      idIntegrador: this.idIntegrador,
      idContato: this.idContato,
      acoes: this.acoes
    };

    this.funcionarioService.transferirItemsVendedor(vm).subscribe(result => {
      this.notificacaoService.sucesso('Transferência realizada com sucesso!');
      this.carregandoService.esconde('salvar');
      this.dialogRef.close(true);
    }, (erro) => {
      this.carregandoService.esconde('salvar');
      this.notificacaoService.erro(erro);
      this.dialogRef.close();
    });
  }

  fechar() {
    this.dialogRef.close();
  }
}
